/*=========================================================================================
  File Name: moduleMerchant.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleMerchantState";
import mutations from "./moduleMerchantMutations";
import actions from "./moduleMerchantActions";
import getters from "./moduleMerchantGetters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
